// Single source of truth for firm facts. Update here; the whole site follows.
export const firm = {
  name: "Nexprime Law Chambers LLP",
  shortName: "Nexprime",
  legalName: "Nexprime Law Chambers LLP",
  tagline: "Advocates & Legal Consultants",
  city: "Jaipur",
  state: "Rajasthan",
  domain: "https://nexprimelawchambers.com",
  email: "nexprimelawchambersllp@gmail.com",
  officePhone: null,
  address: {
    line1: "Shop No. 53-54, Arawali Marg",
    line2: "Mansarovar",
    landmark: "Opp. Maharishi Arvind School",
    city: "Jaipur",
    state: "Rajasthan",
    pin: "302020",
    country: "India",
  },
  hours: [
    "Monday – Saturday, 10:00 AM – 7:00 PM",
    "Sunday, 12:00 PM – 9:00 PM",
  ],
  court: "Rajasthan High Court",
  established: "2026",
  advocates: [
    {
      id: "mohit-meena",
      name: "Mohit Meena",
      monogram: "MM",
      photo: "/assets/advocates/mohit.jpeg",
      degrees: ["B.Com.", "M.Com.", "LL.B.", "PGDCL", "PGDLL"],
      phone: "+91 82906 29429",
    },
    {
      id: "naina-bhaskar",
      name: "Naina Bhaskar",
      monogram: "NB",
      photo: "/assets/advocates/naina.jpeg",
      degrees: ["B.Com.", "LL.B."],
      phone: "+91 90795 38392",
    },
    {
      id: "puneet-jolia",
      name: "Puneet Jolia",
      monogram: "PJ",
      photo: "/assets/advocates/puneet.jpeg",
      degrees: ["B.Com. (Hons.)", "M.Com.", "DFA", "LL.B.", "LL.M."],
      phone: "+91 70625 43599",
    },
  ],
};

export const fullAddress = `${firm.address.line1}, ${firm.address.line2}, ${firm.address.landmark}, ${firm.address.city}, ${firm.address.state} – ${firm.address.pin}`;
// Exact pin: 26°51'37.1"N 75°45'56.9"E
export const officeCoords = { lat: 26.8602943, lng: 75.7658081 };
export const mapsEmbedUrl = `https://www.google.com/maps?q=${officeCoords.lat},${officeCoords.lng}&z=17&hl=en&output=embed`;
export const mapsLink = `https://www.google.com/maps/place/26%C2%B051'37.1%22N+75%C2%B045'56.9%22E/@${officeCoords.lat},${officeCoords.lng},17z/data=!3m1!4b1!4m4!3m3!8m2!3d${officeCoords.lat}!4d${officeCoords.lng}`;
export const telHref = (phone) => `tel:${phone.replace(/[^+\d]/g, "")}`;
